function configuredBoolean(value: boolean | string | undefined, fallback: boolean) {
  if (typeof value === 'boolean') return value;
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    if (normalized === 'true') return true;
    if (normalized === 'false') return false;
  }
  return fallback;
}

const runtimePhase2Available = window.__HELIX_CONFIG__?.phase2Available;

export const featureFlags = Object.freeze({
  phase2Available: configuredBoolean(
    runtimePhase2Available ?? import.meta.env.VITE_PHASE_2_AVAILABLE,
    false,
  ),
});
